/**
 * Clickable patient name component that opens call session details.
 * Used in EnrollmentsPage to deep-link via enrollment context.
 */
import React from 'react';
import { useCallSessionContext } from '../../context/CallSessionContext';

const PatientNameLink = ({ patient, callSessionId = null, enrollment = null, className = "" }) => {
  const { openCallSessionDetails } = useCallSessionContext();

  const handleClick = (e) => {
    e.preventDefault();
    if (patient?.id) {
      // Use enrollment context (when provided) to load full details
      openCallSessionDetails(patient, callSessionId, enrollment);
    }
  };

  if (!patient) {
    return <span className="text-gray-500">N/A</span>;
  }

  return (
    <button
      onClick={handleClick}
      className={`font-medium text-gray-900 hover:text-blue-600 hover:underline cursor-pointer ${className}`}
    >
      {patient.full_name || `${patient.first_name} ${patient.last_name}`}
    </button>
  );
};

export default PatientNameLink;